import React from 'react';

import {Link} from "react-router-dom";

import {ListItem, ListItemIcon, Tooltip} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
    menuListItem: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
}))

const MenuIconButton = (props) => {
    const {label, icon, route} = props

    const classes = useStyles()

    return (
        <Tooltip title={label} placement={'right'} arrow>
            <ListItem
                className={classes.menuListItem}
                button
                component={Link}
                to={route}
            >
                <ListItemIcon>
                    {icon}
                </ListItemIcon>
            </ListItem>
        </Tooltip>
    );
};

export default MenuIconButton;